import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-level",
  "use": "icon-level-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-level\"><defs><style type=\"text/css\"></style></defs><path d=\"M810.667 533.333H213.333a21.333 21.333 0 0 1 0-42.666h597.334a21.333 21.333 0 1 1 0 42.666z\" p-id=\"3797\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol